
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      radiovalue: 'ListDirector',
      spinning: true,
      key: new Date().getTime() + '',
      expandedRowKeys: [],
      showradio: true,
      nodatadesc: (props.itemdata || {}).title,
      pagination: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTitle: false
      },
      pag: null,
      ListDirector: [],
      ListSupervisor: [],
      ListExecutives: []
    })
    pageData.columns = [
      {
        title: '姓名',
        dataIndex: 'LeaderName',
        key: 'LeaderName',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '职务',
        dataIndex: 'Position',
        key: 'Position',
        width: '130px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'ShareAmount',
        key: 'ShareAmount',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '薪酬(元)',
        dataIndex: 'AnnualReward',
        key: 'AnnualReward',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '任职开始日',
        dataIndex: 'BeginningDate',
        key: 'BeginningDate',
        width: '100px'
      },
      {
        title: '学历',
        dataIndex: 'LeaderDegree',
        key: 'LeaderDegree',
        width: '80px'
      },
      {
        title: '年龄',
        dataIndex: 'BirthYM',
        key: 'BirthYM',
        width: '80px'
      },
      {
        title: '性别',
        dataIndex: 'LeaderGender',
        key: 'LeaderGender',
        width: '80px'
      },
      {
        title: '报告期',
        dataIndex: 'EndDate',
        key: 'EndDate',
        width: '100px'
      }
    ]

    function changeradio() {
      const _data = (props.pageSourceData || {}).ShareList || {}
      let list: any = null
      if (!(_data.ListDirector || []).length && !(_data.ListSupervisor || []).length && !(_data.ListExecutives || []).length) {
        pageData.showradio = false
        pageData.nodatadesc = (props.itemdata || {}).title
      } else {
        pageData.showradio = true
        if (!(_data.ListDirector || []).length) {
          pageData.nodatadesc = '董事会'
          pageData.ListDirector = _data.ListDirector
        } else if (!(_data.ListSupervisor || []).length) {
          pageData.nodatadesc = '监事会'
        } else if (!(_data.ListExecutives || []).length) {
          pageData.nodatadesc = '高管'
          pageData.ListExecutives = _data.ListExecutives
        }
      }
      pageData.ListDirector = _data.ListDirector
      pageData.ListSupervisor = _data.ListSupervisor
      pageData.ListExecutives = _data.ListExecutives
      if (pageData.radiovalue === 'ListDirector') {
        list = JSON.parse(JSON.stringify(_data.ListDirector || []))
      } else if (pageData.radiovalue === 'ListSupervisor') {
        list = JSON.parse(JSON.stringify(_data.ListSupervisor || []))
      } else if (pageData.radiovalue === 'ListExecutives') {
        list = JSON.parse(JSON.stringify(_data.ListExecutives || []))
      }
      if ((list || []).length) {
        list.forEach((item: any, i: any) => {
          item.index = pageData.radiovalue + i
          item.key = pageData.radiovalue + i
          item.description = item.Background
          item.BeginningDate = item.BeginningDate ? window.moment(item.BeginningDate * 1000).format('YYYY-MM-DD') : '—'
          item.EndDate = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
        })
      }
      if ((list || []).length > 10) {
        pageData.pag = pageData.pagination
      } else {
        pageData.pag = false
      }
      nextTick(() => {
        pageData.spinning = false
      })
      pageData.data = list
    }
    watch(
      () => (props.pageSourceData || {}).ShareList || {},
      () => {
        changeradio()
      },
      { deep: true }
    )
    const gglbtable: any = ref()
    return {
      ...toRefs(pageData),
      gglbtable,
      changeradio
    }
  }
})
